import { VideoConsultationNotificationConfiguration } from '@dreryk/egabinet-phone-notification-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { PatientPhoneNotificationVideoConsultationReminderConfigurationModal } from './PatientPhoneNotificationVideoConsultationReminderConfigurationModal';

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpenerProps = {
   videoConsultationNotificationConfiguration: VideoConsultationNotificationConfiguration;
   children: (
      renderProps: PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpenerRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpener = (
   props: PatientPhoneNotificationVideoConsultationReminderConfigurationModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <PatientPhoneNotificationVideoConsultationReminderConfigurationModal
               videoConsultationNotificationConfiguration={props.videoConsultationNotificationConfiguration}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
